"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = {
    key: 0,
    class: "bg-coral-500 w-3 h-3 rounded-full absolute top-0 -right-1"
};
const Basket_1 = require("../../stores/Basket");
const SvgSprite_vue_1 = __importDefault(require("../SvgSprite.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BasketNavIcon',
    setup(__props) {
        const store = (0, Basket_1.useBasketStore)();
        store.fetchBasket();
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.unref)(store).$state.products.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                    href: "icon-basket",
                    class: "w-8 h-8"
                })
            ]));
        };
    }
});
